<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{$route.name}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
            </nav>
            </b-col>
            <!-- <b-col lg="6" cols="5" class="text-right">
            <base-button icon type="neutral" size="lg">
            <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
            <span class="btn-inner--text">New Customer</span>
            </base-button>
            </b-col> -->
        </b-row>
        </base-header>
        <div>
            <!-- <vue-element-loading :active="loading" :is-full-screen="true" color="#fb6340"/> -->
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col lg="12">
                    <div class="card-wrapper">
                        <b-card no-body>
                            <b-tabs pills card>
                                <b-tab :title="language_terms['BASIC_INFORMATION']" active>
                                     <b-card-text>
                                         <card>
                                             <div slot="header">
                                                <b-row>
                                                    <b-col lg="6">
                                                        <h3 >{{language_terms['BASIC_INFORMATION']}} 
                                                            <span v-if="product.code">({{product.code}})</span>
                                                        </h3>
                                                    </b-col>
                                                    <!-- <b-col lg="6" >
                                                        <base-button icon type="danger" class="float-right" @click="deleteProduct" v-if="$route.params.id != '_new'">
                                                            <span class="btn-inner--text">{{language_terms['DELETE']}}</span>
                                                        </base-button>
                                                    </b-col> -->
                                             </b-row>
                                             </div>

                                             <b-row>
                                                <b-col lg="9">
                                                    <base-input :label="language_terms['PRODUCT_NAME']" v-model="product.name" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                <b-col lg="3">
                                                    <base-input :label="language_terms['PRODUCT_CODE']" v-model="product.code" :disabled="isLocked"></base-input>
                                                 </b-col>

                                                <b-col lg="3">
                                                    <base-input :label="language_terms['LIST_PRICE']" v-model="product.sale_list_price" :disabled="isLocked"></base-input>
                                                </b-col>                                                 
                                                <b-col lg="3">
                                                    <base-input :label="language_terms['BASED_UOM']" v-model="product.base_uom" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                <b-col lg="3">
                                                    <base-input :label="language_terms['MOQ']" v-model="product.moq" type="number" :min="0" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                <!-- <b-col lg="3">
                                                    <base-input :label="language_terms['CURRENCY']" :disabled="isLocked">
                                                        <el-select v-model="product.currency_code" filterable :placeholder="language_terms['CURRENCY_CODE']" :disabled="isLocked">
                                                            <el-option v-for="option in currencies"
                                                                        :key="option.id"
                                                                        :label="option.code + ' (' + option.prefix + ')'"
                                                                        :value="option.code">
                                                            </el-option>
                                                        </el-select>
                                                    </base-input>
                                                </b-col> -->
                                                <b-col lg="3">
                                                     <base-input :label="language_terms['STORAGE_CLASSIFICATIONS']" :disabled="isLocked">
                                                        <el-select v-model="product.storageclassification_id" filterable 
                                                        :placeholder="language_terms['STORAGE_CLASSIFICATIONS']" :disabled="isLocked">
                                                            <el-option v-for="option in storage_classifications"
                                                                    :key="option.storageclassification_id"
                                                                    :label="option.storageclassification_name"
                                                                    :value="option.storageclassification_id">
                                                            </el-option>
                                                        </el-select>
                                                     </base-input>
                                                 </b-col>


                                                 <b-col lg="6">
                                                    <label class="form-control-label">{{language_terms['CATEGORIES']}}</label>
                                                    <multiselect
                                                        open-direction="bottom"
                                                        :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                                        :placeholder="language_terms['SEARCH_ADD_TAG']"
                                                        label="name"
                                                        track-by="id"
                                                        :options="product_categories"
                                                        text-field="name"
                                                        :multiple="true"
                                                        v-model="product.category_items"
                                                        :taggable="false"
                                                        :disabled="isLocked"
                                                        ></multiselect>
                                                 </b-col>
                                                 

                                                 <b-col lg="1">
                                                    <base-input label="CBM" v-model="product.cbm" type="number" :min="0" :disabled="isLocked"/>
                                                </b-col>
                                                 <b-col lg="2">
                                                    <base-input :label="language_terms['BRAND']" v-model="product.brand" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                <b-col lg="3">
                                                    <base-input :label="language_terms['MODEL']" v-model="product.model" :disabled="isLocked"></base-input>
                                                 </b-col>
                                                <!-- <b-col lg="12">
                                                    <base-input :label="language_terms['PRODUCT_DESP_LONG']" > 
                                                        <textarea class="form-control" rows="3" v-model="product.desp_long"></textarea>
                                                    </base-input>
                                                    <html-editor v-model="product.desp_long"></html-editor>
                                                 </b-col> -->
                                             </b-row>
                                             <b-row>
                                                <b-col lg="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_sold" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['IS_SOLD']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                <b-col lg="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_purchased" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['IS_PURCHASED']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                <b-col lg="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_inventorized" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['IS_INVENTORIZED']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                <b-col lg="2" v-if="product.is_trade == '0'">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_bom" value="1" unchecked-value="0" :disabled="isLocked" >
                                                        {{language_terms['IS_BOM']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                <b-col lg="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.has_lot" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['HAS_LOT']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                                 <b-col lg="2">
                                                    <b-form-checkbox class="mb-3" v-model="product.is_trade" value="1" unchecked-value="0" :disabled="isLocked">
                                                        {{language_terms['IS_TRADE_ITEM']}}
                                                    </b-form-checkbox>
                                                 </b-col>
                                             </b-row>
                                            <hr v-if="(product.is_bom == '1')"/>
                                             <b-row v-if="(product.is_bom == '1')"> 
                                                 <b-col cols="12">
                                                    <h3>{{language_terms['BOM_COMPONENTS']}}</h3>
                                                 </b-col>
                                                <b-col lg="12">
                                                    <base-input :label="language_terms['BOM_CONFIGURABLE']" :disabled="isLocked">
                                                        <el-select v-model="product.is_bom_configurable" filterable :disabled="isLocked" @change="onChangeBomProperty">
                                                            <el-option v-for="option in bom_configurable_options"
                                                                        :key="option.code"
                                                                        :label="language_terms[option.name]"
                                                                        :value="option.code">
                                                            </el-option>
                                                        </el-select>
                                                    </base-input>
                                                 </b-col>
                                                <template v-if="product.is_bom_configurable == '0'">
                                                    <b-col lg="4">
                                                        <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                                                        <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="bom.product_code" :v2="product.id" :disabled="isLocked"/>
                                                    </b-col>
                                                    <b-col lg="4">
                                                        <base-input :label="language_terms['QTY']" v-model="bom.qty" type="number" :min="0" :disabled="isLocked"></base-input>
                                                    </b-col>
                                                    <b-col lg="3">
                                                        <base-input :label="language_terms['UOM']" >
                                                            <el-select v-model="bom.uom" filterable :disabled="isLocked">
                                                                <el-option v-for="option in uom_list"
                                                                        :key="option.code"
                                                                        :label="option.code"
                                                                        :value="option.code">
                                                                </el-option>
                                                            </el-select>
                                                        </base-input>
                                                    </b-col>
                                                    <b-col lg="1" class='mt-4'>
                                                        <base-button type="primary" class='mt-2' @click.native="addBom" :disabled="isLocked">
                                                            <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                                        </base-button>
                                                    </b-col>
                                                    <b-col lg="12">
                                                        <div>
                                                            <b-table :items="product.product_boms" :fields="bomTabelFields" head-variant="light"  v-if="product.product_boms.length > 0">
                                                                <template #cell(index)="data">
                                                                    {{data.index + 1}}
                                                                </template>
                                                                <template #cell(price_adjustment) ="data">
                                                                    {{data.item.price_adjustment == null ? '-': data.item.price_adjustment }}
                                                                </template>
                                                                <template #cell(is_default)="data">
                                                                    {{(data.item.is_default ) ? language_terms['YES'] : language_terms['NO']}}
                                                                </template>
                                                                <template #cell(deleteBtn)="row">
                                                                    <base-button icon type="warning" @click="removeBom(row.index)" size="sm" :disabled="isLocked">
                                                                        <i class="fa fa-trash"></i>
                                                                    </base-button>
                                                                </template>
                                                            </b-table>
                                                        </div>
                                                    </b-col>
                                                </template>
                                                <template v-else>
                                                    <b-col cols="8">
                                                        <base-input :label="language_terms['GROUP_NAME']" v-model="bom.group_name" type="text" :disabled="isLocked"></base-input> 
                                                    </b-col>
                                                    <b-col cols="2">
                                                        <base-input :label="language_terms['MAX_SELECTION_COUNT']" v-model="bom.max_selection_count" type="number" :disabled="isLocked" :min="1"></base-input> 
                                                    </b-col>
                                                    <b-col lg="2" class="mt-4">
                                                        <base-button type="primary" @click.native="addBomGroup" :disabled="isLocked" class="mb-3 mt-2">
                                                            <span class="btn-inner--text"><i class="fa fa-plus mr-2"></i >{{language_terms['ADD_GROUP']}}</span>
                                                        </base-button>
                                                    </b-col>
                                                    <b-col cols="12" v-for="(item, i) in product.product_boms" :key="i">
                                                        <b-card>
                                                            <b-row>
                                                                <b-col cols="8">
                                                                    <h5 class="mb-0">
                                                                        <span class="text-primary">{{item.group_name}}</span> 
                                                                        <span class="text-success ml-2"> - {{language_terms['MAX_SELECTION_COUNT']}} </span> 
                                                                        <span>({{item.max_selection_count}})</span> 
                                                                    </h5>
                                                                </b-col>
                                                                <b-col cols="4">
                                                                    <base-button @click="handleCollaspeBomGroup(i, item)" size="sm" icon type="success" class="float-right"><i class="fa fa-angle-down"></i></base-button>
                                                                    <base-button @click="deleteBomGroup(i)" size="sm" icon type="danger" class="float-right mr-4" :disabled="isLocked"><i class="fas fa-trash-alt" ></i ></base-button>
                                                                    <base-button @click="performAddProductToGroup(i)" size="sm" icon type="primary" class="float-right mr-4" :disabled="isLocked"><i class="fa fa-plus"></i> {{language_terms['ADD_PRODUCT']}}</base-button>
                                                                </b-col> 
                                                                <b-col cols="12">
                                                                    <b-collapse v-model="item.is_collapsed" class="mt-2">
                                                                        <b-row> 
                                                                            <b-col lg="12">
                                                                                <div>
                                                                                <b-table :items="item.boms" :fields="bomTabelFields" head-variant="light"  v-if="item.boms.length > 0">
                                                                                        <template #cell(index)="data">
                                                                                            {{data.index + 1}}
                                                                                        </template>
                                                                                        <template #cell(is_default)="data">
                                                                                            <!-- {{(data.item.is_default == "1") ? language_terms['YES'] : language_terms['NO']}} -->
                                                                                            <b-form-checkbox v-model="data.item.is_default" value="1" unchecked-value="0" @change="clickOnIsDefaultbox(i, data.index)"><!-- {{language_terms['IS_DEFAULT']}} --></b-form-checkbox>
                                                                                        </template>
                                                                                        <template #cell(price_adjustment) ="data">
                                                                                            {{data.item.price_adjustment == null ? '-': data.item.price_adjustment }}
                                                                                        </template>
                                                                                        <template #cell(deleteBtn)="row">
                                                                                            <base-button icon type="warning" @click="removeBomItemFromGroup(row.index, i)" size="sm" :disabled="isLocked">
                                                                                                <i class="fa fa-trash"></i>
                                                                                            </base-button>
                                                                                        </template>
                                                                                    </b-table>
                                                                                </div>
                                                                            </b-col>        
                                                                        </b-row>                                                        
                                                                    </b-collapse>
                                                                </b-col>

                                                            </b-row>
                                                        </b-card>
                                                    </b-col>
                                                </template>
                                             </b-row>
                                             <!-- <hr/> -->
                                             <b-row>
                                                <!-- <b-col cols="12">
                                                    <h3>{{language_terms['OTHERS']}}</h3>
                                                </b-col> -->
                                                <b-col lg="2" v-if="product.is_sold == 1">
                                                    <base-input :label="language_terms['SALES_ACCOUNT']">
                                                        <el-select v-model="product.sale_account_code" filterable :disabled="isLocked">
                                                            <el-option v-for="option in account_options"
                                                                :key="option.code"
                                                                :label="option.code + ' - ' + option.name"
                                                                :value="option.code">
                                                            </el-option>
                                                        </el-select>
                                                    </base-input>
                                                </b-col>
                                                <b-col lg="2" v-if="product.is_sold == 1">
                                                    <base-input :label="language_terms['SALES'] + ' ' + language_terms['TAX_CODE']" :disabled="isLocked">
                                                        <el-select v-model="product.sale_tax_code" filterable :disabled="isLocked">
                                                            <el-option v-for="option in tax_codes"
                                                                    :key="option.code"
                                                                    :label="option.name"
                                                                    :value="option.code">
                                                            </el-option>
                                                        </el-select>
                                                     </base-input>
                                                </b-col>

                                                <b-col lg="2" v-if="product.is_purchased == 1">
                                                    <base-input :label="language_terms['PURCHASE_ACCOUNT']">
                                                        <el-select v-model="product.purchase_account_code" filterable :disabled="isLocked">
                                                            <el-option v-for="option in account_options"
                                                                :key="option.code"
                                                                :label="option.code + ' - ' + option.name"
                                                                :value="option.code">
                                                            </el-option>
                                                        </el-select>
                                                    </base-input>
                                                </b-col>

                                                <b-col lg="2" v-if="product.is_purchased == 1">
                                                    <base-input :label="language_terms['PURCHASE'] + ' ' + language_terms['TAX_CODE']" :disabled="isLocked">
                                                        <el-select v-model="product.purchase_tax_code" filterable :disabled="isLocked">
                                                            <el-option v-for="option in tax_codes"
                                                                    :key="option.code"
                                                                    :label="option.name"
                                                                    :value="option.code">
                                                            </el-option>
                                                        </el-select>
                                                     </base-input>
                                                </b-col>

                                                <b-col lg="2" v-if="product.is_inventorized == 1">
                                                    <base-input :label="language_terms['INVENTORY_ACCOUNT']">
                                                        <el-select v-model="product.inventory_account_code" filterable :disabled="isLocked">
                                                            <el-option v-for="option in account_options"
                                                                :key="option.code"
                                                                :label="option.code + ' - ' + option.name"
                                                                :value="option.code">
                                                            </el-option>
                                                        </el-select>
                                                    </base-input>
                                                </b-col>

                                                <b-col lg="2" v-if="product.is_inventorized == 1">
                                                    <base-input :label="language_terms['REORDER_QTY']" v-model="product.qty_min" :disabled="isLocked" type="number"></base-input>
                                                </b-col>
                                                <b-col lg="3" v-if="0">
                                                <base-input :label="language_terms['EXPIRY_MONTHS']" v-model="product.expiry_mths" :disabled="isLocked" type="number"></base-input>
                                                </b-col>
                                                <b-col lg="3" v-if="0">
                                                    <base-input :label="language_terms['WARRANTY_MONTHS']" v-model="product.warranty_mths" :disabled="isLocked" type="number"></base-input>
                                                </b-col>
                                                <b-col lg="3" v-if="0">
                                                    <base-input :label="language_terms['RESERVATION_MAX_DAYS']" v-model="product.reservation_max_days" :disabled="isLocked" type="number"></base-input>
                                                </b-col>
                                                <!-- <b-col lg="3">
                                                    <base-input :label="language_terms['SALES_QUOTATION_VALIDITY_DAYS']" v-model="product.sales_quotation_validity_days" :disabled="isLocked" type="number"></base-input>
                                                </b-col> -->
                                             </b-row>
                                             <hr/>
                                             <b-row>
                                                 <b-col cols="12">
                                                    <h3>{{language_terms['PRODUCT_LANGUAGES']}}</h3>
                                                 </b-col>
                                                 <b-col cols="12" v-for="(item, index) of product.languages" :key="index">
                                                     <b-card>
                                                         <b-row>
                                                             <b-col cols="10">
                                                                <img :src="`/flag-icons/${item.icon}.png`" class="mr-3">
                                                                {{item.language_name}}
                                                             </b-col>
                                                             <b-col cols="2">
                                                                <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" class="float-right mr-1"><i class="fa fa-angle-down"></i></base-button>
                                                             </b-col>
                                                         </b-row>
                                                        <b-collapse v-model="item.is_collapsed" class="mt-2">
                                                            <b-row>
                                                                <b-col cols="6">
                                                                    <base-input :label="language_terms['PRODUCT_NAME']" v-model="item.name" :disabled="isLocked" type="text"></base-input>
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <base-input :label="language_terms['DESP']" v-model="item.desp" :disabled="isLocked" type="text"></base-input>
                                                                </b-col>
                                                                <b-col cols="12">
                                                                    <vue-editor v-model="item.desp_html" :editorToolbar="customToolbar" :disabled="isLocked" ></vue-editor>
                                                                </b-col>
                                                            </b-row>
                                                        </b-collapse>
                                                     </b-card>
                                                 </b-col>
                                             </b-row>

                                         </card>
                                     </b-card-text>
                                        <div class="floating-bar">
                                            <div class="floating-bar-container" align="center">
                                                <b-button-group>
                                                    <b-button class="transparent-btn"  @click="showFloatBtn" v-if="!isShowBtn">
                                                        <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn"  @click="saveProduct" v-if="isShowBtn">
                                                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn"  @click="cancelProduct" v-if="isShowBtn">
                                                        <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                                                    </b-button>
                                                    <b-button class="transparent-btn" @click="deleteProduct" v-if="$route.params.id != '_new'">
                                                        <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </div>
                                        <!-- <div>
                                            <a href="javascript:void(0)" class="float-button " @click="showFloatBtn" style="background-color:#2dce89" v-if="!isShowBtn">
                                                <i class="fa fa-edit  my-float-button" aria-hidden="true"></i>
                                            </a>
                                            <a href="javascript:void(0)" class="float-button " @click="cancelProduct" style="background-color:#fb6340" v-if="isShowBtn">
                                                <i class="fa fa-times  my-float-button" aria-hidden="true"></i>
                                            </a>
                                            <a href="javascript:void(0)" class="float-button mr-7" @click="saveProduct" style="background-color:#5e72e4" v-if="isShowBtn">
                                                <i class="fas fa-check my-float-button"></i>
                                            </a>
                                        </div> -->
                                </b-tab>
                                <b-tab :title="language_terms['UOM']" v-if="show_tabs">
                                   <b-card-text>
                                        <card>
                                            <h3 slot="header">{{language_terms['UOM']}}</h3>
                                            <b-row>
                                                <b-col cols="4">
                                                    <base-input :label="language_terms['UOM']" v-model="uom.code"></base-input>
                                                </b-col>
                                                <b-col cols="3">
                                                    <base-input :label="language_terms['MULTIPLIER']" v-model="uom.multiplier" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="4">
                                                    <base-input :label="language_terms['UNIT_PRICE']" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                <b-col lg="1" class='mt-4'>
                                                    <base-button  type="primary" class='mt-2' @click.native="addProductUom">
                                                        <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                                    </base-button>
                                                 </b-col>
                                            </b-row>
                                            <b-row v-if="product.product_uoms.length > 0">
                                                <b-col lg="12">
                                                    <b-table-simple hover>
                                                        <b-thead head-variant="light">
                                                            <b-th>{{language_terms['UOM']}}</b-th>
                                                            <b-th>{{language_terms['MULTIPLIER']}}</b-th>
                                                            <b-th>{{language_terms['UNIT_PRICE']}}</b-th>
                                                            <b-th>{{language_terms['IS_DEFAULT']}}</b-th>
                                                            <b-th></b-th>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <tr v-for="(item, j) in product.product_uoms" :key="j">
                                                                <td>{{item.code}}</td>
                                                                <td>{{item.multiplier}}</td>
                                                                <td>{{item.unit_price ? item.unit_price : '-'}}</td>
                                                                <td>{{(item.is_default == 1) ? language_terms['YES'] : language_terms['NO'] }}</td>
                                                                <td>
                                                                    <base-button icon type="warning" @click="deleteUOM(item)" size="sm" :disabled="(item.is_default == 1)">
                                                                        <i class="fa fa-trash" aria-hidden="true" ></i>
                                                                    </base-button>
                                                                </td>
                                                            </tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </b-col>
                                            </b-row>
                                        </card>
                                   </b-card-text>
                                </b-tab>
                                <b-tab :title="language_terms['CODES']" v-if="show_tabs">
                                    <b-card-text>
                                        <card>
                                            <h3 slot="header">{{language_terms['CODES']}}</h3>
                                            <b-row>
                                                <b-col lg="3">
                                                    <base-input :label="language_terms['TYPE']">
                                                        <el-select v-model="product_code.type" filterable >
                                                        <el-option v-for="option in code_types"
                                                                    :key="option.code"
                                                                    :label="option.name"
                                                                    :value="option.code">
                                                        </el-option>
                                                        </el-select>
                                                    </base-input>
                                                </b-col>
                                                <b-col lg="4">
                                                    <base-input :label="language_terms['CODE']" v-model="product_code.code"></base-input>
                                                 </b-col>
                                                <b-col lg="3">
                                                    <base-input :label="language_terms['TAG']" v-model="product_code.tag"></base-input>
                                                 </b-col>
                                                <b-col lg="2" class='mt-4'>
                                                    <base-button  type="primary" class='mt-2' @click.native="addProductCode">
                                                        <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                                    </base-button>
                                                 </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col lg="12" v-for="(code, index) in product.product_codes" :key="index">
                                                    <b-card>
                                                        <b-row>
                                                            <b-col cols="4">
                                                                <barcode :value="code.code" :tag="'svg'" :options="options_upc" v-if="code.type == 'barcode_upc'" ></barcode>
                                                                <barcode :value="code.code" :tag="'svg'" :options="options_code_128" v-if="code.type == 'barcode_code128'" ></barcode>
                                                                <qr-code :text="code.code" v-if="code.type == 'qrcode'" :size="size"></qr-code>
                                                            </b-col>
                                                            <b-col cols="3">
                                                                <base-input :label="language_terms['VALUE']" v-model="code.code" disabled></base-input>
                                                            </b-col>
                                                              <b-col cols="3">
                                                                <base-input :label="language_terms['TAG']" v-model="code.tag" disabled></base-input>
                                                            </b-col>
                                                            <b-col cols="2" class='mt-4'>
                                                                <base-button icon type="warning" @click="deleteCode(code)" class='mt-2 '>
                                                                    <i class="fa fa-trash" aria-hidden="true" ></i>
                                                                </base-button>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card>
                                                </b-col>
                                            </b-row>
                                        </card>
                                    </b-card-text>
                                </b-tab>
                                 <b-tab :title="language_terms['MEDIAS']" v-if="show_tabs">
                                    <b-row>
                                        <b-col cols="12">
                                            <dropzone id="myVueDropzone" 
                                                ref="myVueDropzone" 
                                                class="mb-2" 
                                                :options="dropzoneOptions" 
                                                v-on:vdropzone-sending="sendingImage" 
                                                v-on:vdropzone-removed-file ="removeImage" > 
                                                <input type="hidden" name="token" value="xxx" >
                                            </dropzone>
                                        </b-col>
                                        
                                    </b-row>
                                    <!--Product Medias Display-->
                                    <b-row>
                                        <b-col cols="4" v-for= "option in product.product_medias" :key = option.id>
                                            <card class="container">
                                                <div  style="height:340px;width:340px" class="image">
                                                    <img :src="option.url" class="img-fluid rounded imgColor" v-if="(option.file_extension != 'pdf')">
                                                    <a :href="option.url" target="_blank" v-else><i class="fa fa-file" aria-hidden="true"></i> &nbsp; {{option.file_name}}</a>
                                                </div>
                                                <div class="middle">
                                                    <span class="hoverDelete">{{option.file_name}}</span><br/>
                                                    <base-button  size="sm" type="warning" @click="deleteMedia(option)">
                                                        <i class="fa fa-times"></i>
                                                    </base-button>
                                                </div>
                                            </card>
                                        </b-col>
                                    </b-row>
                                    <!--Product Medias Display End-->
                                </b-tab>
                            </b-tabs>
                        </b-card>
                        <b-row>
                            <b-col md="12">
                                <!-- <base-button icon type="primary"
                                    @click="saveProduct">
                                    <span class="btn-inner--text">{{language_terms['SAVE']}}</span>
                                </base-button> -->
                                <!-- <base-button icon type="danger"
                                    @click="deleteProduct">
                                    <span class="btn-inner--text">{{language_terms['DELETE']}}</span>
                                </base-button> -->
                                <!-- <base-button icon type="warning" @click="cancelProduct">
                                    <span class="btn-inner--text">{{language_terms['CANCEL']}}</span>
                                </base-button> -->
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <b-modal v-model="add_bom_product_modal" :header-bg-variant="'primary'"  size="lg" centered class="my-modal" >
            <template #modal-title>
                <span style="color: white">{{language_terms['ADD_PRODUCT']}}</span>
            </template>
            <b-row>
                <b-col sm="12">
                    <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                    <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="bom.product_code" :v2="product.id" :disabled="isLocked"/>
                </b-col>
                <b-col sm="3">
                    <base-input :label="language_terms['QTY']" v-model="bom.qty" type="number" :min="0" :disabled="isLocked"></base-input>
                </b-col>
                <b-col sm="3">
                    <base-input :label="language_terms['UOM']" >
                        <el-select v-model="bom.uom" filterable :disabled="isLocked">
                            <el-option v-for="option in uom_list"
                                    :key="option.code"
                                    :label="option.code"
                                    :value="option.code">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col sm="3">
                    <base-input :label="language_terms['PRICE_ADJUSTMENT']" v-model="bom.price_adjustment" type="number" :disabled="isLocked"></base-input>
                </b-col>
                <b-col sm="3">
                    <base-input :label="language_terms['IS_DEFAULT']" >
                        <el-select v-model="bom.is_default" filterable :disabled="isLocked">
                            <el-option v-for="option in is_default_options"
                                    :key="option.code"
                                    :label="option.label"
                                    :value="option.code">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
            </b-row>
                <template #modal-footer="{ ok, cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button variant="primary" @click="addBomItemToGroup()">
                    {{language_terms['ADD']}}
                </b-button>
                <b-button variant="danger" @click="cancelAddBomModal()">
                    {{language_terms['CANCEL']}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Vue from 'vue';
import { mapState } from "vuex";
import { Select, Option } from 'element-ui'
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import VueBarcode from 'vue-barcode'
import VueQRCodeComponent from 'vue-qrcode-component'
import BaseButton from '../../components/BaseButton.vue';

import {apiRoutes} from "../../apiRoutes"
import { authHeader } from '../../global';
import Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'

import productLookup from "@/components/Autocomplete.vue";


import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import { VueEditor } from "vue2-editor";

export default {
  name:'Product-Details',
  data(){
      return{
        tax_codes:[
        {code: 'S', name:'Standard Rated'},
        {code: 'Z', name:'Zero Rated'},            
        ],
        account_options:[],
        add_bom_product_modal:false,
        selected_group_index:-1,
        show_add_group:false,
        customToolbar: [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ["bold", "italic", "underline", "strike"],
            [
                { align: "" },
                { align: "center" },
                { align: "right" },
                { align: "justify" }
            ],
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            ["image", "blockquote", "link", "clean"]
        ],
        bom_configurable_options:[
            {code:"1", name :"CONFIGURABLE"},
            {code:"0", name :"FIXED"} 
        ],
        is_default_options:[
            {code:1, label :"YES"},
            {code:0, label :"NO"}
        ],
        bomTabelFields: [
            { key: 'index', label: 'SNO' },
            { key: 'product_code', label: 'PRODUCT_CODE' },
            { key: 'product_name', label: 'PRODUCT_NAME' },
            { key: 'qty', label: 'QTY' },
            { key: 'uom_code', label: 'UOB_CODE' },
            { key: 'price_adjustment', label: 'PRICE_ADJUSTMENT' },
            { key: 'is_default', label: 'IS_DEFAULT' },
            { key: 'deleteBtn', label: 'ACTION' },
        ],
        apiProductLookup: apiRoutes["LOOKUP_PRODUCT_FOR_BOM"],
        bom:{
            max_selection_count:1,
            price_adjustment:null,
            group_no:"",
            group_name:"",
            uom:"",
            uom_code:"",
            qty:null,
            product_id:'',
            product_code:'',
            is_default:1
        },
        dropzoneOptions: 
        {
            maxFiles: 1,
            url: "https://httpbin.org/post",
            thumbnailWidth: 200,
            addRemoveLinks: false,
            maxFilesize: 20,
                headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+ localStorage.access_token
                }
        },
        isLocked:true,
        isShowBtn:false,
        loading:false,
        size:150,
        show_tabs:true,
        uom:{
            code:"",
            multiplier:null,
            unit_price:null
        },
        product_code:{
            code:"",
            type:"barcode_code128",
            tag:""
        },
        code_types:[
            {code:'barcode_upc', name:'BARCODE_UPC'},
            {code:'barcode_code128', name:'BARCODE_CODE_128'},
            {code:'qrcode', name:'QRCODE'}
        ],
        product:{
            sale_tax_code:'S',
            purchase_tax_code:'S',
            sale_account_code:null,
            purchase_account_code:null,
            inventory_account_code:null,
            languages:[],
            code:"",
            name:"",
            has_lot:0,
            is_trade:0,
            has_expiry:0,
            has_warranty:0,
            is_trade:0,
            warranty_mths:null,
            expiry_mths:null,
            reservation_max_days:null,
            is_sold:1,
            is_purchased:1,
            is_inventorized:1,
            base_uom:"",
            desp:"",
            desp_long:"",
            brand:"",
            model:"",
            sale_list_price:null,
            moq:"",
            is_active:1,
            is_bom_configurable:"0",
            sales_quotation_validity_days:null,
            category_items:[],
            product_codes:[],
            product_medias:[],
            product_boms:[],
            product_uoms:[],
            currency_code:"",
          },
            options_code_128: {
                format: "CODE128",
                lineColor: '#ff7069',
                fontSize: 32,
                font: 'Courier',
                width: 3,
                height: 30,
                marginBottom: 60,
                background: '#ccffff'
            },
            options_upc: {
                format: "upc",
                lineColor: '#ff7069',
                fontSize: 32,
                font: 'Courier',
                width: 3,
                height: 30,
                marginBottom: 60,
                background: '#ccffff'
            },
      }
  },
  components:
  {
    VueEditor,
    productLookup,
    Loading,
    Dropzone,
    // VueElementLoading,
    HtmlEditor,
    [Select.name]: Select,
    [Option.name]: Option,
    'barcode':VueBarcode,
    'qr-code':VueQRCodeComponent,
    BaseButton
  },
  computed:{
      ...mapState({
        default_sq_validity_days: state => state.sales.default_sq_validity_days,
        storage_classifications: state => state.storageclassifications.storage_classifications,
        product_filter: state =>  state.products.filter,
        product_is_created: state => state.products.is_created,
        product_is_updated: state => state.products.is_updated,
        product_is_deleted: state => state.products.is_deleted,
        is_bom_created: state => state.productBom.is_created,
        is_bom_deleted:state => state.productBom.is_deleted,
        uom_list:state => state.products.uom_list, 
        currencies: state => state.currencies.currencies,
        taxes: state => state.taxes.taxes,
        countries: state => state.countries.countries,
        product_data: state => state.products.product_data,
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
        product_categories: state => state.products.product_categories,
        product_media_is_updated: state => state.productMedias.is_updated,
        product_media_is_deleted: state => state.productMedias.is_deleted,
        active_languages:state => state.languages.active_languages,
        default_uom:state => state.products.default_uom

      }),
  },
  async mounted()
  {
      this.loading=true
      this.loadDefaults()

      if(this.$route.params.id == '_new')
      {
          this.show_tabs = false
          this.isLocked = false
          this.isShowBtn = true
          this.product.languages = this.active_languages
          this.product.base_uom = this.default_uom
      }
      else
      {
        await this.retrieveProduct(this.$route.params.id)
        this.product = this.product_data

        if(this.product.languages == null || this.product.languages.length == 0)
        {
            this.product.languages = this.active_languages
        }
        else
        {
            this.product.languages.forEach(function(element) {
                element.is_collapsed =  false
            });
        }

        this.show_tabs = true
      }
        // Language term chages for code 
        for(let i = 0; i< this.code_types.length; i++)
        {
            this.code_types[i].name = this.language_terms[this.code_types[i].name]
        }

        // if(!this.product.sales_quotation_validity_days)
        // {
        //     this.product.sales_quotation_validity_days = this.default_sq_validity_days
        // }

        this.updateBomFiledTerms()


        this.loading = false

  },
  watch:{
        language_terms: {
            handler(val){
                this.updateBomFiledTerms()
            },
            deep: true
        }
  },
  methods:
  {
    async loadAccounts()
    {
        let payload = []
        await axios
        .post(apiRoutes["GET_ACCOUNTS_FOR_FY"], payload, authHeader())
        .then((response) => 
        {
            if (response.data.code == 1) {
                this.account_options = response.data.data
            } 
            else 
                Vue.notify({group: "notify", type: "error", text: response.data.msg, max: 5, duration: 5000, speed: 300,});
        })
        .catch((error) => {
            if (error.response) {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
        });
    },
    async loadDefaults()
    {
        await this.loadCurrencies()
        await this.loadCategories()
        await this.loadAccounts()
        await this.$store.dispatch('storageclassifications/fetchAll', {})
        await this.$store.dispatch("languages/fetchActiveLanguages", {})
        await this.$store.dispatch("products/getDefaultUOM", {})
    },
    clickOnIsDefaultbox(group_index, bom_item_index)
    {
        let count = this.hasDefaultCount(this.product.product_boms[group_index].boms);
        let max_selection_count = this.product.product_boms[group_index].max_selection_count

        if(this.product.product_boms[group_index].boms[bom_item_index].is_default == '1')
        {
           if(count <= max_selection_count)
           {
               this.product.product_boms[group_index].boms[bom_item_index].is_default = 1
           }
           else
           {
               this.product.product_boms[group_index].boms[bom_item_index].is_default = 0
           }
        }

    },
    cancelAddBomModal()
    {
        this.add_bom_product_modal = false
    },
    performAddProductToGroup(group_index)
    {
        this.selected_group_index = group_index
        this.add_bom_product_modal = true
    },
    setDefault(row, bom_index, group_index)
    {

        let bom_items = this.product.product_boms[group_index].boms
        //console.log(bom_items)

        for(let i = 0; i < bom_items.length; i++)
        {
            this.product.product_boms[group_index].boms[i].is_default = '0'
        }

        this.product.product_boms[group_index].boms[bom_index].is_default = '1'
        
    },
    addBomGroup()
    {
        this.bom.group_no = (this.product.product_boms.length * 1) + 1;

        if(this.bom.group_name == '' || this.bom.group_name == null)
        {
            alert("Please enter a group name!");
        }
        else
        {
            if(this.bom.max_selection_count == '' || this.bom.max_selection_count == null)
            {
                alert("Please enter max selection count!");
            }
            else
            {
                if(this.bom.group_name != '' && this.isFoundInList(this.bom.group_name) == 0)
                {
                    this.product.product_boms.push(
                        {
                            group_no:this.bom.group_no, 
                            group_name:this.bom.group_name, 
                            max_selection_count:this.bom.max_selection_count,
                            boms:[],
                            is_collapsed:true
                        })
                    this.bom.group_no = ""
                }
                else
                {
                    alert("The group number already exist!");
                }
            }

        }

    },
 
    onChangeBomProperty(selectedVal)
    {
        if(this.product.is_bom_configurable == 1)
        {
            this.show_add_group = true
        }
        else
        {
            this.show_add_group = false
        }

        this.product.product_boms = []
    },
    handleCollaspeBomGroup(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }

        this.$set(this.product.product_boms, index , row) 

    },
    async deleteBomGroup(index) 
    {
      if (index != -1) 
      {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
                  confirmButtonText: this.language_terms['YES'],
                  cancelButtonText: this.language_terms['CANCEL'],
                  type: 'warning'
                }).catch(() => {
              this.$message.info(this.language_terms['ACTION_CANCEL'])
             })
        if (response === 'confirm') {
             this.loading =true
             this.product.product_boms.splice(index, 1)
             this.loading =false
        }
      }
    },
    handleCollaspe(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }

        this.$set(this.product.languages, index , row) 
    },
    updateBomFiledTerms()
    {
        for(let i = 0; i< this.bomTabelFields.length; i++)
        {
            this.bomTabelFields[i].label = this.language_terms[this.bomTabelFields[i].label]
        }
    },
    async deleteMedia(option)
    {
      if (option.id) 
      {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRM'], {    
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['NO'],
            type: 'warning'
        }).catch(() => 
        {
          this.$message.info(this.language_terms['ACTION_CANCEL'])
        })
        if (response === 'confirm') 
        {
            this.loading =true
            await this.$store.dispatch("productMedias/delete", {id:option.id})
            if(this.product_media_is_deleted)
            {
                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
            }
            this.loading =false
        }
      }
    },
    async deleteBom(row)
    {
        if(row)
        {   
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
                confirmButtonText: this.language_terms['YES'],
                cancelButtonText: this.language_terms['CANCEL'],
                type: 'warning'
            }).catch(() => {
                this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') 
            {
                this.loading = true
                let payload = {id:row.id, parent_product_id:row.parent_product_id}
                await this.$store.dispatch("productBom/delete", payload)
                if(this.is_bom_deleted)
                {
                    await this.retrieveProduct(this.product.code)
                    this.product = this.product_data
                }
                this.loading = false
            }
        }

    },
    async selectProduct(obj)
    {
        if(obj)
        {
            this.bom.product_id = obj.id
            this.bom.product_code = obj.code
            this.bom.product_name = obj.name

            await this.$store.dispatch("products/listUoms", {product_id:obj.id})


            if(this.uom_list.length > 0)
            {
                this.bom.uom = this.uom_list[0]
            }
        }
    },
    removeBomItemFromGroup(bom_item_index, group_index)
    {
        this.product.product_boms[group_index].boms.splice(bom_item_index, 1)    
    },
    hasDefaultCount(items)
    {
        let count = 0;

        for(let x = 0; x < items.length; x++)
        {
            if(items[x].is_default == '1')
            {
                count++;
            }
        }

        return count
    },
    addBomItemToGroup()
    {
        let index = this.selected_group_index
        
        if(index != -1)
        {
            let isValid = 1;
            let max_selection_count = (this.product.product_boms[index].max_selection_count) * 1
            let count = this.hasDefaultCount(this.product.product_boms[index].boms) * 1

            if(count >= max_selection_count)
            {
                if(this.bom.is_default == 1)
                {
                    isValid = 0;
                }
            }

            if(isValid == 1)
            {
                console.log("A")
                this.bom.uom_code = this.bom.uom.code
                if(this.bom.product_id && this.bom.qty && this.bom.uom_code)
                {
                    this.product.product_boms[index].boms.push(this.bom)
                    this.bom = {
                        uom:"",
                        uom_code:"",
                        qty:null,
                        product_id:'',
                        product_code:'',
                        is_default:0
                    }
                }
                this.add_bom_product_modal = false
            }
            else
            {
                alert("Default product counts must be <= Max Selection!");
            }

        }

    },
    async addBom()
    {
        this.bom.uom_code = this.bom.uom.code
        if(this.bom.product_id && this.bom.qty && this.bom.uom_code)
        {

            this.product.product_boms.push(this.bom)

            let is_default = 0;
            if(this.product.is_bom_configurable == '0')
            {
                is_default = 1;
            }

            this.bom = {
                uom:"",
                group_code:"",
                group_name:"",
                uom_code:"",
                qty:null,
                product_id:'',
                product_code:'',
                is_default:is_default
            }
        }
        
    },
    isFoundInList(group_name)
    {
        let is_found = 0
        for(let i = 0; i < this.product.product_boms.length; i++)
        {
            if(this.product.product_boms[i].group_name == group_name)
            {
              is_found = 1
            }
        }
        return is_found;
    },
    async removeBom(index)
    {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
        confirmButtonText: this.language_terms['YES'],
        cancelButtonText: this.language_terms['CANCEL'],
        type: 'warning'
        }).catch(() => {
          this.$message.info(this.language_terms['ACTION_CANCEL'])
        })
        if (response === 'confirm') {
             this.loading = true
             this.product.product_boms.splice(index, 1)    
             this.loading = false
        }
 
    },
    async createBom()
    {
        this.bom.parent_product_id = this.product.id
        this.bom.uom_code = this.bom.uom.code
        await this.$store.dispatch("productBom/create", this.bom)

        if(this.is_bom_created)
        {
            await this.retrieveProduct(this.product.code)
            this.product = this.product_data

            this.bom = {
                uom:"",
                uom_code:"",
                qty:null,
                product_id:'',
                product_code:'',
                is_default:0
            }
        }
    },
    async sendingImage (file, xhr, formData) {
            let product_id = this.product.id
            await axios.post(apiRoutes['PRODUCT_MEDIA_UPLOAD'], formData, authHeader()).then (res =>{
                if (res.data.code == 1)
                {
                    // console.log(res.data.data)
                    let upload_id = res.data.data.upload_id
                    let payload = {upload_id:upload_id, product_id}

                    this.$store.dispatch("productMedias/update", payload)

                    console.log("BB")
                     // Push image to array
                    let media = {
                         id:upload_id,
                         product_id:product_id,
                         url:res.data.data.url,
                         file_alias:res.data.data.file_alias,
                         file_name:res.data.data.file_name,
                         file_extension:res.data.data.file_extension
                     }
                     this.product.product_medias.push(media);

                    this.$refs.myVueDropzone.removeFile(file)


                }
                else 
                {
                    this.alertMessage = res.data.msg
                    this.alertModal = true
                }
            })
            .catch(error => alert("Error: " + error))
        },
        removeImage(file)
        { 
         console.log(file) 
        },
      showFloatBtn(){
          this.isShowBtn = true
          this.isLocked = false


      },
     async deleteUOM(item)
    {
        if(item.id)
        {
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['CANCEL'],
            type: 'warning'
            }).catch(() => {
            this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') 
            {
                this.loading = true
                await this.$store.dispatch("productUoms/delete", item)
                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
                this.loading = false
            }
        }
    },
      async deleteCode(code){
        if(code.id)
        {
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['CANCEL'],
            type: 'warning'
            }).catch(() => {
            this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') {
                this.loading = true
                await this.$store.dispatch("productCodes/delete", code)
                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
                this.loading = false
            }
            
        }
           
      },
    async addProductUom()
    {
        if(this.uom.code && this.uom.multiplier)
        {
            this.uom.product_id = this.product.id
            console.log(this.product_code)

            await this.$store.dispatch("productUoms/create", this.uom)
           
            await this.retrieveProduct(this.product.code)
            this.product = this.product_data

            this.uom = {code:"",multiplier:null,unit_price:null}
        }
    },
    async addProductCode()
    {
        if(this.product_code.type && this.product_code.code)
        {
            // Create Product Code
            this.product_code.product_id = this.product.id
            console.log(this.product_code)
            await this.$store.dispatch("productCodes/create", this.product_code)
           
            await this.retrieveProduct(this.product.code)
            this.product = this.product_data

            this.product_code = {code:"",type:"barcode_code128",tag:""}

        }
        else
        {
            Vue.notify({
              group: "notify",
              type: "error",
              text: this.language_terms['ERROR_MSG_ADD_PRODUCT_CODE'],
              max: 5,
              duration: 5000,
              speed: 300,
            });
        }
    },
    async retrieveProduct(code)
    {
        this.loading=true
        await this.$store.dispatch("products/fetch", {
          code:code
        });
        this.loading=false
        //this.product = this.product_data
    },
    loadCategories(){
        this.loading=true
        this.$store.dispatch("products/fetchAllCategories", {})
        this.loading=false
    },
    loadCurrencies(){
        this.loading=true
        this.$store.dispatch("currencies/fetchAll", {});
        this.loading=false
    },
    async searchProducts()
    {
        this.loading = true
        let filter = {keyword:"",active_only:"1"}
        if(this.product_filter)
        {
            filter = this.product_filter
        }
        await this.$store.dispatch('products/quickSearch', filter)

        this.loading = false
    },
    async saveProduct()
    {
      this.loading=true
      if(this.$route.params.id == '_new')
      {
        await this.$store.dispatch("products/create", this.product);
        if(this.product_is_created)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
      }
      else
      {
        await this.$store.dispatch("products/update", this.product);
        if(this.product_is_updated)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
      }
      this.loading=false
    },
    async deleteProduct(){
       // alert("delete")
        await this.$store.dispatch("products/delete", {id:this.product.id});
        if(this.product_is_deleted)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
     

    },
    cancelProduct(){
            if(this.$route.params.id == '_new')
            {
                this.$router.push("/users/master")
            }
            else
            {
                location.reload();
            }    }
  }
}
</script>
<style lang="scss">
.container {
  position: relative;
}

.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: .5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.container:hover .image {
  opacity: 0.3;
}
.container:hover .middle {
  opacity: 1;
}


</style>